
import { apiFetch } from './fetchApi'

// export const fetchJob = (BeURL, setAllJobs, showAlert, currentPage, rowsPerPage, setTotal, setTotalPage) => {
//     apiFetch(`${BeURL}/fetch-jobs`,{
//         method : "GET",
//         credentials : 'include'
//     })
//     .then(res=>res.json())
//     .then(data=>{
//         if(data.success){
//             setAllJobs(data.jobs)
//             showAlert(data.message)
//         }
//         else{
//             alert(data.message)
//         }
//     })
//     .catch(err=>{
//         console.log("Error in fetch job" ,err)
//     })
// }



export const fetchJob = async (BeURL, setAllJobs, showAlert, currentPage = 1, rowsPerPage = 10, setTotal = null, setTotalPage = null, activeIndex = 0, fromDate = "", toDate = "", searchKeyword = "") => {
    try {
        const queryParams = new URLSearchParams({
            page: currentPage,
            limit: rowsPerPage,

        });
        if (activeIndex) {
            queryParams.append("value", activeIndex);
        }

        if (fromDate || toDate) {
            queryParams.append("fromDate", fromDate);
            queryParams.append("toDate", toDate);
        }
        if (searchKeyword.jobId) {
            queryParams.append("jobId", searchKeyword.jobId);
            // queryParams.append("toDate", toDate);
        }

        if (searchKeyword.title) {
            queryParams.append("title", searchKeyword.title);
            // queryParams.append("toDate", toDate);
        }

        if (searchKeyword.client) {
            queryParams.append("client", searchKeyword.client);
            // queryParams.append("toDate", toDate);
        }

        if (searchKeyword.spoc) {
            queryParams.append("spoc", searchKeyword.spoc);
            // queryParams.append("toDate", toDate);
        }
        console.log("fetching")
        const res = await apiFetch(`${BeURL}/fetch-jobs?${queryParams.toString()}`, {
            method: "GET",
            credentials: "include",
        });
        const data = await res.json();
        console.log("Fetched :", data);
        if (data.success) {
            console.log("fetching 2")
            setAllJobs(data.jobs);
            setTotal(data.totalJobs);
            setTotalPage(data.totalPage);
        } else {
            showAlert(data.message);
        }
    } catch (err) {
        console.error("Error in fetch job:", err);
        // showAlert("Failed to fetch jobs", "error");
    }

};




